import { PosElapsedTimeModule } from './../pos-elapsed-time/pos-elapsed-time.module';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosDocumentsStepModalModule } from './../pos-documents-step-modal/pos-documents-step-modal.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DocumentsStepModule } from './../../views/credit-request/components/documents-step/documents-step.module';
import { PosCreditRequestRequirementDetailComponent } from './pos-credit-request-requirement-detail.component';

@NgModule({
  declarations: [PosCreditRequestRequirementDetailComponent],
  imports: [
    CommonModule,
    AccordionModule,
    ReactiveFormsModule,
    FormsModule,
    PosTableModule,
    PosDocumentsStepModalModule,
    PosElapsedTimeModule
  ],
  exports: [PosCreditRequestRequirementDetailComponent],
})
export class PosCreditRequestRequirementDetailModule {}
